var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetToLandmarks(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M3.515.038a17.449 17.449 0 0 0 .83 1.33c-1.58.245-2.66.715-2.66 1.04 0 .433 1.929 1.127 4.405 1.197l.65.726.672-.749c2.23-.141 3.903-.77 3.903-1.175 0-.294-.887-.707-2.23-.965l.14-.206c.25-.371.48-.739.686-1.1 1.713.429 2.848 1.21 2.848 2.271 0 1.67-2.813 2.649-6.259 2.649S.24 4.077.24 2.407C.24 1.261 1.569.44 3.516.038z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#263238",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(6 10.74)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5.056c3.446 0 6.26-.979 6.26-2.649h-1.445c0 .458-2.145 1.204-4.815 1.204-2.67 0-4.815-.746-4.815-1.204H.241c0 1.67 2.813 2.649 6.259 2.649z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.63 10.776a.994.994 0 0 0 .37-.771v-5.53A3.38 3.38 0 0 1 12.74 4a3.35 3.35 0 0 1 3.371 3.37c0 2.504-3.37 6.26-3.37 6.26s-1.154-1.286-2.111-2.854zm2.11-2.202c-.673 0-1.203-.53-1.203-1.204 0-.674.53-1.203 1.204-1.203.674 0 1.203.53 1.203 1.203 0 .674-.53 1.204-1.203 1.204z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.429 6.429H0V10h3.571V8.571H1.43V6.43zM0 3.57h1.429V1.43H3.57V0H0v3.571zm8.571 5H6.43V10H10V6.429H8.571V8.57zM6.43 0v1.429H8.57V3.57H10V0H6.429z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetToLandmarks);
export default __webpack_public_path__ + "static/media/Reset-to-Landmarks.4ae321a9c56ea64319595d263962a7b4.svg";
export { ForwardRef as ReactComponent };